<template>
  <div class="layout-menu-container">
    <AppSubmenu
      :items="model"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
      @keydown="onKeyDown"
    />

    <div class="layout-menu">
      <span class="p-buttonset">
        <Button @click="logout" label="Se déconnecter" icon="pi pi-sign-out" />
      </span>
    </div>
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu";
export default {
  props: {
    model: Array,
  },
  methods: {
    logout() {
     localStorage.removeItem("permissionNames");
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        this.permissionNames = [];
        this.user = {};
        this.token = "";
        this.$router.push('/login')
    },
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
    onKeyDown(event) {
      const nodeElement = event.target;
      if (event.code === "Enter" || event.code === "Space") {
        nodeElement.click();
        event.preventDefault();
      }
    },
    bannerImage() {
      return this.$appState.darkTheme
        ? "images/banner-primeblocks-dark.png"
        : "images/banner-primeblocks.png";
    },
  },
  computed: {
    darkTheme() {
      return this.$appState.darkTheme;
    },
  },
  components: {
    AppSubmenu: AppSubmenu,
  },
};
</script>